// GENERATED by `python -m enex_app.core.contracts.ts_types` from the Pydantic contracts.
// Do not edit by hand: change the contract in backend/enex_app/core/contracts and run the generator.

import type * as T from "./types";

export type Who = "anyone" | "P" | "E" | "S" | "ES" | "A" | "owner" | "agent";

export interface RouteInfo {
  name: string;
  kind: "command" | "query";
  /** GET, POST, PUT, PATCH or DELETE; empty for the agent-only commands. */
  method: string;
  /** The path with `{param}` placeholders; empty for the agent-only commands. */
  path: string;
  who: Who;
  multipart: boolean;
}

export const ROUTES: Record<string, RouteInfo> = {
  accept_card: { name: "accept_card", kind: "command", method: "POST", path: "/api/ws/cards/{id}/accept", who: "E", multipart: false },
  add_by_hand: { name: "add_by_hand", kind: "command", method: "POST", path: "/api/ws/elements", who: "E", multipart: false },
  add_discipline: { name: "add_discipline", kind: "command", method: "POST", path: "/api/admin/disciplines", who: "A", multipart: false },
  add_line: { name: "add_line", kind: "command", method: "POST", path: "/api/ws/elements/{id}/lines", who: "E", multipart: false },
  add_note: { name: "add_note", kind: "command", method: "POST", path: "/api/ws/notes", who: "ES", multipart: false },
  add_spot_by_hand: { name: "add_spot_by_hand", kind: "command", method: "POST", path: "/api/ws/spots", who: "E", multipart: false },
  add_workspace: { name: "add_workspace", kind: "command", method: "POST", path: "/api/admin/workspaces", who: "A", multipart: false },
  admin_answer_question: { name: "admin_answer_question", kind: "command", method: "POST", path: "/api/admin/conversations/{key}/answers", who: "A", multipart: false },
  admin_cancel_turn: { name: "admin_cancel_turn", kind: "command", method: "POST", path: "/api/admin/conversations/{key}/turns/{turn_id}/cancel", who: "A", multipart: false },
  admin_conversation: { name: "admin_conversation", kind: "query", method: "GET", path: "/api/admin/conversations/{key}", who: "A", multipart: false },
  admin_disciplines: { name: "admin_disciplines", kind: "query", method: "GET", path: "/api/admin/disciplines", who: "A", multipart: false },
  admin_memory: { name: "admin_memory", kind: "query", method: "GET", path: "/api/admin/memory", who: "A", multipart: false },
  admin_people: { name: "admin_people", kind: "query", method: "GET", path: "/api/admin/people", who: "A", multipart: false },
  admin_workspaces: { name: "admin_workspaces", kind: "query", method: "GET", path: "/api/admin/workspaces", who: "A", multipart: false },
  answer_question: { name: "answer_question", kind: "command", method: "POST", path: "/api/ws/conversations/{key}/answers", who: "owner", multipart: false },
  ask_lock: { name: "ask_lock", kind: "command", method: "POST", path: "/api/ws/elements/{id}/lock/ask", who: "E", multipart: false },
  ask_why: { name: "ask_why", kind: "command", method: "POST", path: "/api/ws/cards/{id}/ask-why", who: "E", multipart: false },
  asset: { name: "asset", kind: "query", method: "GET", path: "/api/ws/assets/{id}", who: "ES", multipart: false },
  attach_deliverable: { name: "attach_deliverable", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/deliverables", who: "E", multipart: false },
  back_lane: { name: "back_lane", kind: "query", method: "GET", path: "/api/ws/back-from-sme", who: "E", multipart: false },
  cancel_intake: { name: "cancel_intake", kind: "command", method: "POST", path: "/api/ws/deliverables/{id}/intake/cancel", who: "E", multipart: false },
  cancel_turn: { name: "cancel_turn", kind: "command", method: "POST", path: "/api/ws/conversations/{key}/turns/{turn_id}/cancel", who: "owner", multipart: false },
  capabilities: { name: "capabilities", kind: "query", method: "GET", path: "/api/ws/capabilities", who: "ES", multipart: false },
  capability_view: { name: "capability_view", kind: "query", method: "GET", path: "/api/ws/capabilities/{id}", who: "ES", multipart: false },
  card: { name: "card", kind: "query", method: "GET", path: "/api/ws/cards/{id}", who: "ES", multipart: false },
  change_accept_card: { name: "change_accept_card", kind: "command", method: "POST", path: "/api/ws/cards/{id}/change-accept", who: "E", multipart: false },
  change_connection_point: { name: "change_connection_point", kind: "command", method: "POST", path: "/api/ws/symbols/{code}/points", who: "E", multipart: false },
  change_discipline_note: { name: "change_discipline_note", kind: "command", method: "PATCH", path: "/api/ws/discipline-notes/{id}", who: "E", multipart: false },
  change_password: { name: "change_password", kind: "command", method: "POST", path: "/api/auth/change-password", who: "P", multipart: false },
  change_plan: { name: "change_plan", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/plan", who: "E", multipart: false },
  change_roles: { name: "change_roles", kind: "command", method: "PATCH", path: "/api/admin/memberships/{id}", who: "A", multipart: false },
  chapter: { name: "chapter", kind: "query", method: "GET", path: "/api/ws/chapters/{key}", who: "ES", multipart: false },
  checks_list: { name: "checks_list", kind: "query", method: "GET", path: "/api/ws/checks", who: "ES", multipart: false },
  clear_my_memory: { name: "clear_my_memory", kind: "command", method: "DELETE", path: "/api/ws/me/memory", who: "owner", multipart: false },
  clear_part_mark: { name: "clear_part_mark", kind: "command", method: "DELETE", path: "/api/ws/items/{id}/parts/{part}", who: "E", multipart: false },
  close_batch: { name: "close_batch", kind: "command", method: "POST", path: "/api/ws/batches/{id}/close", who: "E", multipart: false },
  close_discipline: { name: "close_discipline", kind: "command", method: "POST", path: "/api/admin/disciplines/{code}/close", who: "A", multipart: false },
  close_open_point: { name: "close_open_point", kind: "command", method: "POST", path: "/api/ws/open-points/{id}/close", who: "E", multipart: false },
  close_workspace: { name: "close_workspace", kind: "command", method: "POST", path: "/api/admin/workspaces/{code}/close", who: "A", multipart: false },
  confirm_discipline_note: { name: "confirm_discipline_note", kind: "command", method: "POST", path: "/api/ws/discipline-notes/offers/{id}/confirm", who: "E", multipart: false },
  confirm_intake: { name: "confirm_intake", kind: "command", method: "POST", path: "/api/ws/deliverables/{id}/intake/confirm", who: "E", multipart: false },
  conversation: { name: "conversation", kind: "query", method: "GET", path: "/api/ws/conversations/{key}", who: "owner", multipart: false },
  convert_symbol: { name: "convert_symbol", kind: "command", method: "POST", path: "/api/ws/symbols/convert", who: "E", multipart: true },
  correct_code: { name: "correct_code", kind: "command", method: "POST", path: "/api/ws/elements/{id}/code", who: "E", multipart: false },
  correct_spot: { name: "correct_spot", kind: "command", method: "PATCH", path: "/api/ws/spots/{id}", who: "E", multipart: false },
  counters: { name: "counters", kind: "query", method: "GET", path: "/api/ws/counters", who: "ES", multipart: false },
  coverage_report: { name: "coverage_report", kind: "query", method: "GET", path: "/api/ws/coverage/{report_id}", who: "ES", multipart: false },
  create_account: { name: "create_account", kind: "command", method: "POST", path: "/api/admin/people", who: "A", multipart: false },
  decline_card: { name: "decline_card", kind: "command", method: "POST", path: "/api/ws/cards/{id}/decline", who: "E", multipart: false },
  deliverable: { name: "deliverable", kind: "query", method: "GET", path: "/api/ws/deliverables/{id}", who: "ES", multipart: false },
  deliverable_kinds: { name: "deliverable_kinds", kind: "query", method: "GET", path: "/api/ws/document-kinds", who: "ES", multipart: false },
  deliverable_lines: { name: "deliverable_lines", kind: "query", method: "GET", path: "/api/ws/document-kinds/{id}/lines", who: "ES", multipart: false },
  disable_account: { name: "disable_account", kind: "command", method: "POST", path: "/api/admin/people/{id}/disable", who: "A", multipart: false },
  discipline_notes: { name: "discipline_notes", kind: "query", method: "GET", path: "/api/ws/discipline-notes", who: "ES", multipart: false },
  disciplines: { name: "disciplines", kind: "query", method: "GET", path: "/api/disciplines", who: "P", multipart: false },
  display_card: { name: "display_card", kind: "command", method: "POST", path: "/api/ws/inbox/cards/{element_id}/display", who: "S", multipart: false },
  drop_discipline_note: { name: "drop_discipline_note", kind: "command", method: "POST", path: "/api/ws/discipline-notes/offers/{id}/drop", who: "E", multipart: false },
  drop_line_next_version: { name: "drop_line_next_version", kind: "command", method: "POST", path: "/api/ws/lines/{id}/next-version/drop", who: "E", multipart: false },
  drop_next_version: { name: "drop_next_version", kind: "command", method: "POST", path: "/api/ws/elements/{id}/next-version/drop", who: "E", multipart: false },
  edit_admin_memory: { name: "edit_admin_memory", kind: "command", method: "PATCH", path: "/api/admin/memory", who: "A", multipart: false },
  edit_chapter_section: { name: "edit_chapter_section", kind: "command", method: "PUT", path: "/api/ws/chapters/{key}/sections/{section}", who: "E", multipart: false },
  edit_element: { name: "edit_element", kind: "command", method: "PATCH", path: "/api/ws/elements/{id}", who: "E", multipart: false },
  edit_hand_over: { name: "edit_hand_over", kind: "command", method: "PATCH", path: "/api/ws/hand-overs/{id}", who: "E", multipart: false },
  edit_line: { name: "edit_line", kind: "command", method: "PATCH", path: "/api/ws/lines/{id}", who: "E", multipart: false },
  edit_my_memory: { name: "edit_my_memory", kind: "command", method: "PATCH", path: "/api/ws/me/memory", who: "owner", multipart: false },
  element: { name: "element", kind: "query", method: "GET", path: "/api/ws/elements/{id}", who: "ES", multipart: false },
  element_graph: { name: "element_graph", kind: "query", method: "GET", path: "/api/ws/elements/{id}/graph", who: "ES", multipart: false },
  element_impact: { name: "element_impact", kind: "query", method: "GET", path: "/api/ws/elements/{id}/impact", who: "ES", multipart: false },
  enable_account: { name: "enable_account", kind: "command", method: "POST", path: "/api/admin/people/{id}/enable", who: "A", multipart: false },
  enter_step: { name: "enter_step", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/step", who: "E", multipart: false },
  events_after: { name: "events_after", kind: "query", method: "GET", path: "/api/ws/events", who: "ES", multipart: false },
  export_workspace: { name: "export_workspace", kind: "command", method: "POST", path: "/api/admin/workspaces/{code}/export", who: "A", multipart: false },
  family_tree: { name: "family_tree", kind: "query", method: "GET", path: "/api/ws/tree", who: "ES", multipart: false },
  file_preview: { name: "file_preview", kind: "query", method: "GET", path: "/api/ws/files/preview", who: "ES", multipart: false },
  files_view: { name: "files_view", kind: "query", method: "GET", path: "/api/ws/files", who: "ES", multipart: false },
  find_in_ontology: { name: "find_in_ontology", kind: "query", method: "GET", path: "/api/ws/search/ontology", who: "ES", multipart: false },
  finish_session: { name: "finish_session", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/finish", who: "E", multipart: false },
  grant_membership: { name: "grant_membership", kind: "command", method: "POST", path: "/api/admin/people/{id}/memberships", who: "A", multipart: false },
  hand_over: { name: "hand_over", kind: "query", method: "GET", path: "/api/ws/hand-overs/{id}", who: "ES", multipart: false },
  health: { name: "health", kind: "query", method: "GET", path: "/api/health", who: "anyone", multipart: false },
  heartbeat_lock: { name: "heartbeat_lock", kind: "command", method: "POST", path: "/api/ws/elements/{id}/lock/still-editing", who: "E", multipart: false },
  history_feed: { name: "history_feed", kind: "query", method: "GET", path: "/api/ws/history-feed", who: "ES", multipart: false },
  home: { name: "home", kind: "query", method: "GET", path: "/api/ws/home", who: "ES", multipart: false },
  inbox: { name: "inbox", kind: "query", method: "GET", path: "/api/ws/inbox", who: "S", multipart: false },
  item_backlog: { name: "item_backlog", kind: "query", method: "GET", path: "/api/ws/parked", who: "ES", multipart: false },
  item_page: { name: "item_page", kind: "query", method: "GET", path: "/api/ws/items/{id}/page", who: "ES", multipart: false },
  item_parts: { name: "item_parts", kind: "query", method: "GET", path: "/api/ws/items/{id}/parts", who: "ES", multipart: false },
  item_snapshot: { name: "item_snapshot", kind: "query", method: "GET", path: "/api/ws/items/{id}/snapshot", who: "ES", multipart: false },
  latest_coverage: { name: "latest_coverage", kind: "query", method: "GET", path: "/api/ws/coverage", who: "ES", multipart: false },
  library_list: { name: "library_list", kind: "query", method: "GET", path: "/api/ws/library/libraries", who: "ES", multipart: false },
  library_search: { name: "library_search", kind: "query", method: "GET", path: "/api/ws/library/search", who: "ES", multipart: false },
  library_term: { name: "library_term", kind: "query", method: "GET", path: "/api/ws/library/term", who: "ES", multipart: false },
  lift_line_removal: { name: "lift_line_removal", kind: "command", method: "POST", path: "/api/ws/lines/{id}/removal/lift", who: "E", multipart: false },
  lift_removal: { name: "lift_removal", kind: "command", method: "POST", path: "/api/ws/elements/{id}/removal/lift", who: "E", multipart: false },
  list_chapters: { name: "list_chapters", kind: "query", method: "GET", path: "/api/ws/chapters", who: "ES", multipart: false },
  list_deliverables: { name: "list_deliverables", kind: "query", method: "GET", path: "/api/ws/deliverables", who: "ES", multipart: false },
  list_elements: { name: "list_elements", kind: "query", method: "GET", path: "/api/ws/elements", who: "ES", multipart: false },
  list_hand_overs: { name: "list_hand_overs", kind: "query", method: "GET", path: "/api/ws/hand-overs", who: "ES", multipart: false },
  list_models: { name: "list_models", kind: "command", method: "POST", path: "/api/admin/model-connection/models", who: "A", multipart: false },
  list_my_models: { name: "list_my_models", kind: "command", method: "POST", path: "/api/me/personal-key/models", who: "P", multipart: false },
  list_sessions: { name: "list_sessions", kind: "query", method: "GET", path: "/api/ws/sessions", who: "ES", multipart: false },
  live_feed: { name: "live_feed", kind: "query", method: "GET", path: "/api/ws/live-feed", who: "ES", multipart: false },
  load_project_list: { name: "load_project_list", kind: "command", method: "POST", path: "/api/ws/project-lists", who: "E", multipart: true },
  log_open_point: { name: "log_open_point", kind: "command", method: "POST", path: "/api/ws/open-points", who: "E", multipart: false },
  make_restore_point: { name: "make_restore_point", kind: "command", method: "POST", path: "/api/ws/restore-points", who: "E", multipart: false },
  mark_line_removal: { name: "mark_line_removal", kind: "command", method: "POST", path: "/api/ws/lines/{id}/removal", who: "E", multipart: false },
  mark_removal: { name: "mark_removal", kind: "command", method: "POST", path: "/api/ws/elements/{id}/removal", who: "E", multipart: false },
  me: { name: "me", kind: "query", method: "GET", path: "/api/me", who: "P", multipart: false },
  model_connection: { name: "model_connection", kind: "query", method: "GET", path: "/api/admin/model-connection", who: "A", multipart: false },
  my_memory: { name: "my_memory", kind: "query", method: "GET", path: "/api/ws/me/memory", who: "owner", multipart: false },
  offer_discipline_note: { name: "offer_discipline_note", kind: "command", method: "", path: "", who: "agent", multipart: false },
  onboarding: { name: "onboarding", kind: "query", method: "GET", path: "/api/ws/onboarding", who: "ES", multipart: false },
  onboarding_faq: { name: "onboarding_faq", kind: "query", method: "GET", path: "/api/me/onboarding/faq", who: "P", multipart: false },
  onboarding_slides: { name: "onboarding_slides", kind: "query", method: "GET", path: "/api/me/onboarding/slides", who: "P", multipart: false },
  open_points: { name: "open_points", kind: "query", method: "GET", path: "/api/ws/open-points", who: "ES", multipart: false },
  open_workflow: { name: "open_workflow", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/workflows", who: "E", multipart: false },
  page_image: { name: "page_image", kind: "query", method: "GET", path: "/api/ws/deliverables/{id}/pages/{n}", who: "ES", multipart: false },
  park_spot: { name: "park_spot", kind: "command", method: "POST", path: "/api/ws/spots/{id}/park", who: "E", multipart: false },
  part_kind_view: { name: "part_kind_view", kind: "query", method: "GET", path: "/api/ws/part-kinds/{id}", who: "ES", multipart: false },
  pause_session: { name: "pause_session", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/pause", who: "E", multipart: false },
  pick_symbol: { name: "pick_symbol", kind: "command", method: "POST", path: "/api/ws/elements/{id}/symbol", who: "E", multipart: false },
  plan_go: { name: "plan_go", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/plan/go", who: "E", multipart: false },
  post_admin_message: { name: "post_admin_message", kind: "command", method: "POST", path: "/api/admin/conversations/{key}/messages", who: "A", multipart: false },
  post_message: { name: "post_message", kind: "command", method: "POST", path: "/api/ws/conversations/{key}/messages", who: "owner", multipart: false },
  prepare_hand_over: { name: "prepare_hand_over", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/hand-overs", who: "E", multipart: false },
  presence: { name: "presence", kind: "query", method: "GET", path: "/api/ws/presence", who: "ES", multipart: false },
  preview_restore: { name: "preview_restore", kind: "query", method: "GET", path: "/api/ws/restore-points/{n}/preview", who: "E", multipart: false },
  progress: { name: "progress", kind: "query", method: "GET", path: "/api/ws/progress", who: "ES", multipart: false },
  project_lists: { name: "project_lists", kind: "query", method: "GET", path: "/api/ws/project-lists", who: "ES", multipart: false },
  proposals_waiting: { name: "proposals_waiting", kind: "query", method: "GET", path: "/api/ws/proposals", who: "E", multipart: false },
  propose_again: { name: "propose_again", kind: "command", method: "POST", path: "/api/ws/elements/{id}/propose-again", who: "E", multipart: false },
  propose_cards: { name: "propose_cards", kind: "command", method: "", path: "", who: "agent", multipart: false },
  record_not_used_by_us: { name: "record_not_used_by_us", kind: "command", method: "POST", path: "/api/ws/elements/{id}/not-used-by-us", who: "E", multipart: false },
  record_plan: { name: "record_plan", kind: "command", method: "", path: "", who: "agent", multipart: false },
  record_sweep: { name: "record_sweep", kind: "command", method: "", path: "", who: "agent", multipart: false },
  registration_candidates: { name: "registration_candidates", kind: "query", method: "GET", path: "/api/ws/symbols/{code}/registration-candidates", who: "ES", multipart: false },
  reject: { name: "reject", kind: "command", method: "POST", path: "/api/ws/elements/{id}/reject", who: "S", multipart: false },
  reject_line: { name: "reject_line", kind: "command", method: "POST", path: "/api/ws/lines/{id}/reject", who: "S", multipart: false },
  release_lock: { name: "release_lock", kind: "command", method: "DELETE", path: "/api/ws/elements/{id}/lock", who: "E", multipart: false },
  remember_person: { name: "remember_person", kind: "command", method: "", path: "", who: "agent", multipart: false },
  remove_discipline_note: { name: "remove_discipline_note", kind: "command", method: "DELETE", path: "/api/ws/discipline-notes/{id}", who: "E", multipart: false },
  remove_model_connection: { name: "remove_model_connection", kind: "command", method: "DELETE", path: "/api/admin/model-connection", who: "A", multipart: false },
  remove_personal_key: { name: "remove_personal_key", kind: "command", method: "DELETE", path: "/api/me/personal-key", who: "P", multipart: false },
  reopen_open_point: { name: "reopen_open_point", kind: "command", method: "POST", path: "/api/ws/open-points/{id}/reopen", who: "E", multipart: false },
  repropose: { name: "repropose", kind: "command", method: "POST", path: "/api/ws/elements/{id}/repropose", who: "E", multipart: false },
  request_files_write: { name: "request_files_write", kind: "command", method: "POST", path: "/api/ws/files/write-now", who: "ES", multipart: false },
  reset_password: { name: "reset_password", kind: "command", method: "POST", path: "/api/admin/people/{id}/reset-password", who: "A", multipart: false },
  restore: { name: "restore", kind: "command", method: "POST", path: "/api/ws/restore", who: "E", multipart: false },
  restore_points: { name: "restore_points", kind: "query", method: "GET", path: "/api/ws/restore-points", who: "E", multipart: false },
  resume_session: { name: "resume_session", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/resume", who: "E", multipart: false },
  run_checks: { name: "run_checks", kind: "command", method: "POST", path: "/api/ws/checks/run", who: "ES", multipart: false },
  run_coverage: { name: "run_coverage", kind: "command", method: "POST", path: "/api/ws/coverage/run", who: "ES", multipart: false },
  send_back: { name: "send_back", kind: "command", method: "POST", path: "/api/ws/elements/{id}/send-back", who: "S", multipart: false },
  send_chapter: { name: "send_chapter", kind: "command", method: "POST", path: "/api/ws/chapters/{key}/send", who: "E", multipart: false },
  send_hand_over: { name: "send_hand_over", kind: "command", method: "POST", path: "/api/ws/hand-overs/{id}/send", who: "E", multipart: false },
  session: { name: "session", kind: "query", method: "GET", path: "/api/ws/sessions/{id}", who: "ES", multipart: false },
  session_cards: { name: "session_cards", kind: "query", method: "GET", path: "/api/ws/sessions/{id}/cards", who: "ES", multipart: false },
  session_log: { name: "session_log", kind: "query", method: "GET", path: "/api/ws/sessions/{id}/log", who: "ES", multipart: false },
  set_active_workspace: { name: "set_active_workspace", kind: "command", method: "POST", path: "/api/me/active-workspace", who: "P", multipart: false },
  set_aim: { name: "set_aim", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/aim", who: "E", multipart: false },
  set_capability_step: { name: "set_capability_step", kind: "command", method: "PUT", path: "/api/ws/capabilities/{id}/steps/{step}", who: "E", multipart: false },
  set_model_connection: { name: "set_model_connection", kind: "command", method: "PUT", path: "/api/admin/model-connection", who: "A", multipart: false },
  set_module_status: { name: "set_module_status", kind: "command", method: "POST", path: "/api/ws/onboarding/{module}", who: "ES", multipart: false },
  set_part_mark: { name: "set_part_mark", kind: "command", method: "POST", path: "/api/ws/items/{id}/parts/{part}", who: "E", multipart: false },
  set_personal_key: { name: "set_personal_key", kind: "command", method: "PUT", path: "/api/me/personal-key", who: "P", multipart: false },
  set_same_item_as: { name: "set_same_item_as", kind: "command", method: "POST", path: "/api/ws/elements/{id}/same-item-as", who: "E", multipart: false },
  set_scope: { name: "set_scope", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/scope", who: "E", multipart: false },
  set_shape_marks: { name: "set_shape_marks", kind: "command", method: "POST", path: "/api/ws/symbols/{code}/marks", who: "E", multipart: false },
  set_shape_registration: { name: "set_shape_registration", kind: "command", method: "POST", path: "/api/ws/symbols/{code}/registration", who: "E", multipart: false },
  set_slide_position: { name: "set_slide_position", kind: "command", method: "PUT", path: "/api/me/onboarding/position", who: "P", multipart: false },
  set_spot_not_data: { name: "set_spot_not_data", kind: "command", method: "POST", path: "/api/ws/spots/{id}/not-data", who: "E", multipart: false },
  set_spot_scope: { name: "set_spot_scope", kind: "command", method: "POST", path: "/api/ws/spots/{id}/scope", who: "E", multipart: false },
  set_symbol_points: { name: "set_symbol_points", kind: "command", method: "POST", path: "/api/ws/elements/{id}/symbol-points", who: "E", multipart: false },
  set_target_list: { name: "set_target_list", kind: "command", method: "PUT", path: "/api/ws/document-kinds/{id}/target-list", who: "E", multipart: false },
  settle_no_home_yet: { name: "settle_no_home_yet", kind: "command", method: "POST", path: "/api/ws/cards/{id}/no-home-yet", who: "E", multipart: false },
  settle_spot_home: { name: "settle_spot_home", kind: "command", method: "POST", path: "/api/ws/spots/{id}/home", who: "E", multipart: false },
  shelf: { name: "shelf", kind: "query", method: "GET", path: "/api/ws/shelf", who: "ES", multipart: false },
  sign_in: { name: "sign_in", kind: "command", method: "POST", path: "/api/auth/sign-in", who: "anyone", multipart: false },
  sign_out: { name: "sign_out", kind: "command", method: "POST", path: "/api/auth/sign-out", who: "P", multipart: false },
  sme_card: { name: "sme_card", kind: "query", method: "GET", path: "/api/ws/inbox/cards/{element_id}", who: "S", multipart: false },
  spots: { name: "spots", kind: "query", method: "GET", path: "/api/ws/deliverables/{id}/spots", who: "ES", multipart: false },
  start_intake: { name: "start_intake", kind: "command", method: "POST", path: "/api/ws/deliverables/{id}/intake", who: "E", multipart: false },
  start_practice: { name: "start_practice", kind: "command", method: "POST", path: "/api/ws/practice/start", who: "ES", multipart: false },
  start_session: { name: "start_session", kind: "command", method: "POST", path: "/api/ws/sessions", who: "E", multipart: false },
  start_session_from_backlog: { name: "start_session_from_backlog", kind: "command", method: "POST", path: "/api/ws/parked/{item_name_norm}/start-session", who: "E", multipart: false },
  sweep_session: { name: "sweep_session", kind: "command", method: "POST", path: "/api/ws/sessions/{id}/sweep", who: "E", multipart: false },
  symbol_library: { name: "symbol_library", kind: "query", method: "GET", path: "/api/ws/symbols/library", who: "ES", multipart: false },
  symbol_set: { name: "symbol_set", kind: "query", method: "GET", path: "/api/ws/symbols", who: "ES", multipart: false },
  take_lock: { name: "take_lock", kind: "command", method: "POST", path: "/api/ws/elements/{id}/lock", who: "E", multipart: false },
  take_over_lock: { name: "take_over_lock", kind: "command", method: "POST", path: "/api/ws/elements/{id}/lock/take-over", who: "E", multipart: false },
  team: { name: "team", kind: "query", method: "GET", path: "/api/ws/team", who: "ES", multipart: false },
  test_model_connection: { name: "test_model_connection", kind: "command", method: "POST", path: "/api/admin/model-connection/test", who: "A", multipart: false },
  upload_deliverable: { name: "upload_deliverable", kind: "command", method: "POST", path: "/api/ws/deliverables", who: "E", multipart: true },
  upload_symbol: { name: "upload_symbol", kind: "command", method: "POST", path: "/api/ws/symbols", who: "E", multipart: true },
  validate: { name: "validate", kind: "command", method: "POST", path: "/api/ws/elements/{id}/validate", who: "S", multipart: false },
  validate_line: { name: "validate_line", kind: "command", method: "POST", path: "/api/ws/lines/{id}/validate", who: "S", multipart: false },
  whats_new: { name: "whats_new", kind: "query", method: "GET", path: "/api/ws/whats-new", who: "ES", multipart: false },
  wipe_practice: { name: "wipe_practice", kind: "command", method: "POST", path: "/api/ws/practice/wipe", who: "ES", multipart: false },
  withdraw_element: { name: "withdraw_element", kind: "command", method: "POST", path: "/api/ws/elements/{id}/withdraw", who: "E", multipart: false },
  withdraw_line: { name: "withdraw_line", kind: "command", method: "POST", path: "/api/ws/lines/{id}/withdraw", who: "E", multipart: false },
  withdraw_symbol: { name: "withdraw_symbol", kind: "command", method: "POST", path: "/api/ws/symbols/{code}/withdraw", who: "E", multipart: false },
  write_log_note: { name: "write_log_note", kind: "command", method: "", path: "", who: "agent", multipart: false },
};

/** The request model of each query (its fields are the path parameters, the query parameters or the body). */
export interface QueryInputs {
  admin_conversation: T.AdminConversation;
  admin_disciplines: T.AdminDisciplines;
  admin_memory: T.AdminMemoryQuery;
  admin_people: T.AdminPeople;
  admin_workspaces: T.AdminWorkspaces;
  asset: T.AssetQuery;
  back_lane: T.BackLaneQuery;
  capabilities: T.CapabilitiesQuery;
  capability_view: T.CapabilityViewQuery;
  card: T.CardQuery;
  chapter: T.ChapterQuery;
  checks_list: T.ChecksList;
  conversation: T.ConversationQuery;
  counters: T.CountersQuery;
  coverage_report: T.CoverageReportQuery;
  deliverable: T.DeliverableQuery;
  deliverable_kinds: T.DeliverableKindsQuery;
  deliverable_lines: T.DeliverableLinesQuery;
  discipline_notes: T.DisciplineNotes;
  disciplines: T.DisciplinesQuery;
  element: T.ElementQuery;
  element_graph: T.ElementGraphQuery;
  element_impact: T.ElementImpactQuery;
  events_after: T.EventsAfterQuery;
  family_tree: T.FamilyTreeQuery;
  file_preview: T.FilePreviewQuery;
  files_view: T.FilesViewQuery;
  find_in_ontology: T.FindInOntologyQuery;
  hand_over: T.HandOverQuery;
  health: T.Health;
  history_feed: T.HistoryFeedQuery;
  home: T.Home;
  inbox: T.InboxQuery;
  item_backlog: T.ItemBacklogQuery;
  item_page: T.ItemPageQuery;
  item_parts: T.ItemPartsQuery;
  item_snapshot: T.ItemSnapshotQuery;
  latest_coverage: T.LatestCoverage;
  library_list: T.LibraryList;
  library_search: T.LibrarySearch;
  library_term: T.LibraryTerm;
  list_chapters: T.ListChapters;
  list_deliverables: T.ListDeliverables;
  list_elements: T.ListElements;
  list_hand_overs: T.ListHandOvers;
  list_sessions: T.ListSessions;
  live_feed: T.LiveFeed;
  me: T.Me;
  model_connection: T.ModelConnectionQuery;
  my_memory: T.MyMemory;
  onboarding: T.OnboardingQuery;
  onboarding_faq: T.OnboardingFaqQuery;
  onboarding_slides: T.OnboardingSlidesQuery;
  open_points: T.OpenPointsQuery;
  page_image: T.PageImage;
  part_kind_view: T.PartKindViewQuery;
  presence: T.Presence;
  preview_restore: T.PreviewRestore;
  progress: T.ProgressQuery;
  project_lists: T.ProjectLists;
  proposals_waiting: T.ProposalsWaitingQuery;
  registration_candidates: T.RegistrationCandidatesQuery;
  restore_points: T.RestorePoints;
  session: T.SessionQuery;
  session_cards: T.SessionCards;
  session_log: T.SessionLogQuery;
  shelf: T.ShelfQuery;
  sme_card: T.SmeCardQuery;
  spots: T.SpotsQuery;
  symbol_library: T.SymbolLibraryQuery;
  symbol_set: T.SymbolSetQuery;
  team: T.TeamQuery;
  whats_new: T.WhatsNewQuery;
}

/** The response type of each query. */
export interface QueryResponses {
  admin_conversation: T.ConversationView;
  admin_disciplines: T.DisciplineAdminView[];
  admin_memory: T.PersonMemoryView;
  admin_people: T.AdminPersonView[];
  admin_workspaces: T.WorkspaceAdminView[];
  asset: Blob;
  back_lane: T.BackLane;
  capabilities: T.CapabilityList;
  capability_view: T.CapabilityView;
  card: T.CardView;
  chapter: T.ChapterView;
  checks_list: T.CheckReport;
  conversation: T.ConversationView;
  counters: T.Counters;
  coverage_report: T.CoverageReport;
  deliverable: T.DeliverableView;
  deliverable_kinds: T.DeliverableKindView[];
  deliverable_lines: T.DeliverableLines;
  discipline_notes: T.DisciplineNoteView[];
  disciplines: T.DisciplineView[];
  element: T.ElementView;
  element_graph: T.ElementGraph;
  element_impact: T.ElementImpact;
  events_after: T.EventsAfter;
  family_tree: T.FamilyTree;
  file_preview: T.FilePreview;
  files_view: T.FilesView;
  find_in_ontology: T.OntologyHit[];
  hand_over: T.HandOverView;
  health: T.HealthResponse;
  history_feed: T.HistoryFeed;
  home: T.HomeEngineer | T.HomeSme | T.HomeBoth;
  inbox: T.Inbox;
  item_backlog: T.ItemBacklog;
  item_page: T.ItemPage;
  item_parts: T.ItemParts;
  item_snapshot: T.ItemSnapshot;
  latest_coverage: T.CoverageReport;
  library_list: T.LibraryInfo[];
  library_search: T.LibrarySearchResult;
  library_term: T.TermView;
  list_chapters: T.ChapterView[];
  list_deliverables: T.DeliverableSummary[];
  list_elements: T.ElementListResult;
  list_hand_overs: T.HandOverView[];
  list_sessions: T.SessionInfo[];
  live_feed: T.EventNotice[];
  me: T.MeView;
  model_connection: T.ModelConnectionView;
  my_memory: T.PersonMemoryView;
  onboarding: T.OnboardingView;
  onboarding_faq: T.OnboardingFaq;
  onboarding_slides: T.OnboardingSlides;
  open_points: T.OpenPointView[];
  page_image: Blob;
  part_kind_view: T.PartKindView;
  presence: T.PresenceEntry[];
  preview_restore: T.RestorePreviewView;
  progress: T.ProgressView;
  project_lists: T.ProjectListView[];
  proposals_waiting: T.ProposalsWaiting;
  registration_candidates: T.RegistrationCandidates;
  restore_points: T.RestorePointView[];
  session: T.SessionView;
  session_cards: T.CardView[];
  session_log: T.SessionLog;
  shelf: T.Shelf;
  sme_card: T.SmeCardView;
  spots: T.SpotPage;
  symbol_library: Blob;
  symbol_set: T.SymbolSet;
  team: T.Team;
  whats_new: T.WhatsNew;
}

/** The request model of each command (its fields are the path parameters, the query parameters or the body). */
export interface CommandInputs {
  accept_card: T.AcceptCard;
  add_by_hand: T.AddByHand;
  add_discipline: T.AddDiscipline;
  add_line: T.AddLine;
  add_note: T.AddNote;
  add_spot_by_hand: T.AddSpotByHand;
  add_workspace: T.AddWorkspace;
  admin_answer_question: T.AdminAnswerQuestion;
  admin_cancel_turn: T.AdminCancelTurn;
  answer_question: T.AnswerQuestion;
  ask_lock: T.AskLock;
  ask_why: T.AskWhy;
  attach_deliverable: T.AttachDeliverable;
  cancel_intake: T.CancelIntake;
  cancel_turn: T.CancelTurn;
  change_accept_card: T.ChangeAcceptCard;
  change_connection_point: T.ChangeConnectionPoint;
  change_discipline_note: T.ChangeDisciplineNote;
  change_password: T.ChangePassword;
  change_plan: T.ChangePlan;
  change_roles: T.ChangeRoles;
  clear_my_memory: T.ClearMyMemory;
  clear_part_mark: T.ClearPartMark;
  close_batch: T.CloseBatch;
  close_discipline: T.CloseDiscipline;
  close_open_point: T.CloseOpenPoint;
  close_workspace: T.CloseWorkspace;
  confirm_discipline_note: T.ConfirmDisciplineNote;
  confirm_intake: T.ConfirmIntake;
  convert_symbol: T.ConvertSymbol;
  correct_code: T.CorrectCode;
  correct_spot: T.CorrectSpot;
  create_account: T.CreateAccount;
  decline_card: T.DeclineCard;
  disable_account: T.DisableAccount;
  display_card: T.DisplayCard;
  drop_discipline_note: T.DropDisciplineNote;
  drop_line_next_version: T.DropLineNextVersion;
  drop_next_version: T.DropNextVersion;
  edit_admin_memory: T.EditAdminMemory;
  edit_chapter_section: T.EditChapterSection;
  edit_element: T.EditElement;
  edit_hand_over: T.EditHandOver;
  edit_line: T.EditLine;
  edit_my_memory: T.EditMyMemory;
  enable_account: T.EnableAccount;
  enter_step: T.EnterStep;
  export_workspace: T.ExportWorkspace;
  finish_session: T.FinishSession;
  grant_membership: T.GrantMembership;
  heartbeat_lock: T.HeartbeatLock;
  lift_line_removal: T.LiftLineRemoval;
  lift_removal: T.LiftRemoval;
  list_models: T.ListModels;
  list_my_models: T.ListMyModels;
  load_project_list: T.LoadProjectList;
  log_open_point: T.LogOpenPoint;
  make_restore_point: T.MakeRestorePoint;
  mark_line_removal: T.MarkLineRemoval;
  mark_removal: T.MarkRemoval;
  offer_discipline_note: T.OfferDisciplineNote;
  open_workflow: T.OpenWorkflow;
  park_spot: T.ParkSpot;
  pause_session: T.PauseSession;
  pick_symbol: T.PickSymbol;
  plan_go: T.PlanGoCommand;
  post_admin_message: T.PostAdminMessage;
  post_message: T.PostMessage;
  prepare_hand_over: T.PrepareHandOver;
  propose_again: T.ProposeAgain;
  propose_cards: T.ProposeCards;
  record_not_used_by_us: T.RecordNotUsedByUs;
  record_plan: T.RecordPlan;
  record_sweep: T.RecordSweep;
  reject: T.Reject;
  reject_line: T.RejectLine;
  release_lock: T.ReleaseLock;
  remember_person: T.RememberPerson;
  remove_discipline_note: T.RemoveDisciplineNote;
  remove_model_connection: T.RemoveModelConnection;
  remove_personal_key: T.RemovePersonalKey;
  reopen_open_point: T.ReopenOpenPoint;
  repropose: T.Repropose;
  request_files_write: T.RequestFilesWrite;
  reset_password: T.ResetPassword;
  restore: T.Restore;
  resume_session: T.ResumeSession;
  run_checks: T.RunChecks;
  run_coverage: T.RunCoverage;
  send_back: T.SendBack;
  send_chapter: T.SendChapter;
  send_hand_over: T.SendHandOver;
  set_active_workspace: T.SetActiveWorkspace;
  set_aim: T.SetAim;
  set_capability_step: T.SetCapabilityStep;
  set_model_connection: T.SetModelConnection;
  set_module_status: T.SetModuleStatus;
  set_part_mark: T.SetPartMark;
  set_personal_key: T.SetPersonalKey;
  set_same_item_as: T.SetSameItemAs;
  set_scope: T.SetScope;
  set_shape_marks: T.SetShapeMarks;
  set_shape_registration: T.SetShapeRegistration;
  set_slide_position: T.SetSlidePosition;
  set_spot_not_data: T.SetSpotNotData;
  set_spot_scope: T.SetSpotScope;
  set_symbol_points: T.SetSymbolPoints;
  set_target_list: T.SetTargetList;
  settle_no_home_yet: T.SettleNoHomeYet;
  settle_spot_home: T.SettleSpotHome;
  sign_in: T.SignIn;
  sign_out: T.SignOut;
  start_intake: T.StartIntake;
  start_practice: T.StartPractice;
  start_session: T.StartSession;
  start_session_from_backlog: T.StartSessionFromBacklog;
  sweep_session: T.SweepSession;
  take_lock: T.TakeLock;
  take_over_lock: T.TakeOverLock;
  test_model_connection: T.TestModelConnection;
  upload_deliverable: T.UploadDeliverable;
  upload_symbol: T.UploadSymbol;
  validate: T.Validate;
  validate_line: T.ValidateLine;
  wipe_practice: T.WipePractice;
  withdraw_element: T.WithdrawElement;
  withdraw_line: T.WithdrawLine;
  withdraw_symbol: T.WithdrawSymbol;
  write_log_note: T.WriteLogNote;
}

/** The response type of each command. */
export interface CommandResponses {
  accept_card: T.AcceptCardResult;
  add_by_hand: T.ElementViewWithWarnings;
  add_discipline: T.DisciplineAdminView;
  add_line: T.ElementView;
  add_note: T.ElementView;
  add_spot_by_hand: T.Spot;
  add_workspace: T.WorkspaceAdminView;
  admin_answer_question: T.AnswerResult;
  admin_cancel_turn: T.OkResponse;
  answer_question: T.AnswerResult;
  ask_lock: T.OkResponse;
  ask_why: T.AskWhyResult;
  attach_deliverable: T.SessionView;
  cancel_intake: T.DeliverableView;
  cancel_turn: T.OkResponse;
  change_accept_card: T.AcceptCardResult;
  change_connection_point: T.SymbolSaved;
  change_discipline_note: T.DisciplineNoteView;
  change_password: T.MeView;
  change_plan: T.SessionView;
  change_roles: T.AdminPersonView;
  clear_my_memory: T.PersonMemoryView;
  clear_part_mark: T.ItemParts;
  close_batch: T.SessionView;
  close_discipline: T.DisciplineAdminView;
  close_open_point: T.OpenPointView;
  close_workspace: T.WorkspaceAdminView;
  confirm_discipline_note: T.DisciplineNoteView;
  confirm_intake: T.DeliverableView;
  convert_symbol: T.SymbolConversion;
  correct_code: T.ElementView;
  correct_spot: T.Spot;
  create_account: T.AdminPersonView;
  decline_card: T.CardResult;
  disable_account: T.AdminPersonView;
  display_card: T.SmeCardView;
  drop_discipline_note: T.OkResponse;
  drop_line_next_version: T.ElementView;
  drop_next_version: T.ElementView;
  edit_admin_memory: T.PersonMemoryView;
  edit_chapter_section: T.ChapterView;
  edit_element: T.ElementView;
  edit_hand_over: T.HandOverView;
  edit_line: T.ElementView;
  edit_my_memory: T.PersonMemoryView;
  enable_account: T.AdminPersonView;
  enter_step: T.SessionView;
  export_workspace: T.WorkspaceAdminView;
  finish_session: T.SessionView;
  grant_membership: T.AdminPersonView;
  heartbeat_lock: T.LockView;
  lift_line_removal: T.ElementView;
  lift_removal: T.ElementView;
  list_models: T.ModelList;
  list_my_models: T.ModelList;
  load_project_list: T.ProjectListView;
  log_open_point: T.OpenPointView;
  make_restore_point: T.RestorePointView;
  mark_line_removal: T.ElementView;
  mark_removal: T.ElementView;
  offer_discipline_note: T.CommandResult;
  open_workflow: T.SessionView;
  park_spot: T.Spot;
  pause_session: T.SessionView;
  pick_symbol: T.ElementView;
  plan_go: T.SessionView;
  post_admin_message: T.PostMessageResult;
  post_message: T.PostMessageResult;
  prepare_hand_over: T.HandOverView[];
  propose_again: T.CardResult;
  propose_cards: T.CommandResult;
  record_not_used_by_us: T.ElementView;
  record_plan: T.CommandResult;
  record_sweep: T.CommandResult;
  reject: T.SmeCardView;
  reject_line: T.SmeCardView;
  release_lock: T.OkResponse;
  remember_person: T.CommandResult;
  remove_discipline_note: T.OkResponse;
  remove_model_connection: T.ModelConnectionView;
  remove_personal_key: T.OkResponse;
  reopen_open_point: T.OpenPointView;
  repropose: T.ElementView;
  request_files_write: T.FilesStatus;
  reset_password: T.AdminPersonView;
  restore: T.RestoreResult;
  resume_session: T.SessionView;
  run_checks: T.CheckReport;
  run_coverage: T.CoverageReport;
  send_back: T.SmeCardView;
  send_chapter: T.ElementView;
  send_hand_over: T.HandOverView;
  set_active_workspace: T.MeView;
  set_aim: T.SessionView;
  set_capability_step: T.CapabilityStepView;
  set_model_connection: T.ModelConnectionView;
  set_module_status: T.OnboardingView;
  set_part_mark: T.ItemParts;
  set_personal_key: T.TestResult;
  set_same_item_as: T.ElementView;
  set_scope: T.SessionView;
  set_shape_marks: T.SymbolSaved;
  set_shape_registration: T.SymbolSaved;
  set_slide_position: T.SlidePosition;
  set_spot_not_data: T.Spot;
  set_spot_scope: T.Spot;
  set_symbol_points: T.ElementView;
  set_target_list: T.TargetListEntry;
  settle_no_home_yet: T.NoHomeYetResult;
  settle_spot_home: T.Spot;
  sign_in: T.MeView;
  sign_out: T.OkResponse;
  start_intake: T.DeliverableView;
  start_practice: T.OnboardingView;
  start_session: T.SessionView;
  start_session_from_backlog: T.SessionView;
  sweep_session: T.PostMessageResult;
  take_lock: T.LockView;
  take_over_lock: T.LockView;
  test_model_connection: T.TestResult;
  upload_deliverable: T.DeliverableView[];
  upload_symbol: T.SymbolSaved;
  validate: T.SmeCardView;
  validate_line: T.SmeCardView;
  wipe_practice: T.OnboardingView;
  withdraw_element: T.ElementView;
  withdraw_line: T.ElementView;
  withdraw_symbol: T.SymbolSaved;
  write_log_note: T.CommandResult;
}

export type QueryName = keyof QueryResponses;
export type CommandName = keyof CommandResponses;
